<script lang="ts">
  import type {Suggestion} from "../../generated";
  import type {SqrlListItemModel} from "../../types/squirrel";
  import {onDestroy} from "svelte";
  import {SqrlTestId,SQRL_SUGGESTION_TYPE} from "../../constants/squirrel";
  import {keywords} from "../../store/SuggestionStore";
  import {timeSuggest, timeSuggestRender} from "../../times/TimeFactory";
  import {SUBMIT_TYPE, submitStore} from "../../store/SubmitStore";
  import SqrlListItem from "../interactive/listItem/SqrlListItem.svelte";
  import {COLOR} from "../../constants/color";

  timeSuggest.mark();
  timeSuggestRender.measure();

  function handleClick(suggestion: Suggestion) {
    timeSuggest.measure();
    submitStore.handleSubmit({term: suggestion.term}, suggestion.target, SUBMIT_TYPE.SUGGEST_ITEM, suggestion.type as SQRL_SUGGESTION_TYPE?? SQRL_SUGGESTION_TYPE.SUGGESTION);
  }

  function createModel(suggestion: Suggestion, index: number): SqrlListItemModel {
    return {
      name: "searchSuggest",
      suggestion,
      index,
      leftIcon: {
        icon: suggestion.icon,
        imageDefined: suggestion.image != null,
      },
      rightIcon: {
        icon: "arrow-right",
        style: {color: COLOR.RED_100},
        classNames: ["squirrel_arrow_right-icon"],
        label: "Suche abschicken"
      },
      image: suggestion.image,
    }
  }

  onDestroy(() => {
    timeSuggest.measure();
  })
</script>

<div class="squirrel_searchSuggestions" data-testid={SqrlTestId.SUGGESTION_LIST}>
    <ul class="squirrel_searchSuggestions__list squirrel_border_top">
        {#each $keywords as suggestion, index}
            <SqrlListItem
                params={createModel(suggestion, index)}
                onClickHandler={handleClick}
            />
        {/each}
    </ul>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .squirrel_searchSuggestions {
    background-color: tokens.$oc-base-color-white;
    padding: tokens.$oc-semantic-spacing-0;
    border-radius: tokens.$oc-semantic-border-radius-0 tokens.$oc-semantic-border-radius-0 tokens.$oc-semantic-border-radius-100 tokens.$oc-semantic-border-radius-100;

    .squirrel_border_top {
      border-top: tokens.$oc-semantic-border-width-400 solid tokens.$oc-base-color-gray-25;
    }
  }
</style>
